<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <v-select
            v-model="perPage"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mr-1"
          />

        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">

            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search')"
            />
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon mr-1"
              @click="toggleFilter()"
            >
              <feather-icon
                icon="FilterIcon"
                size="16"
              />
            </b-button>
          </div>
        </b-col>
      </b-row>
      <filter-component
        v-show="FILTER"
        @refetchTable="refetchTable"
      />
    </div>

    <b-table
      ref="additionalExamCheckTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(index)="data">
        {{ (currentPage - 1) * perPage + data.index + 1 }}
      </template>

      <template #cell(apply_doc)="data">
        {{ data.value.full_name }}
      </template>
      <template #cell(apply_doc.dc_type)="data">
        {{ getDcType(data.value) }}
      </template>

      <template #cell(status)="data">
        {{ $langName(getStatus(data.value)) }}
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label=""
          />
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap text-primary">
          <feather-icon
            v-b-toggle.sidebar-form-exam-check
            icon="EditIcon"
            class="cursor-pointer mr-1"
            size="20"
            color="success"
            @click="selectApplyDoc(data.item)"
          />
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>

</template>

<script>
import {
  BButton, BCard, BCol, BFormInput,
  BPagination, BRow, BSpinner, BTable, VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import config from './checkConfig'
import FilterComponent from './ExamCheckFilterComponent.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    vSelect,
    BSpinner,
    FilterComponent,
  },
  data() {
    return {
      isOtm: false,
      isInno: false,
    }
  },
  computed: {
    universityList() {
      return this.$store.state.staticModule.universityList
    },
  },
  mounted() {
    this.extraParams = {
      additional_exam: this.$route.params.id,
    }
    this.loadData()
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id).name[this.$i18n.locale]
    },
    toggleFilter() {
      this.FILTER = !this.FILTER
    },
    refetchTable(extraParams) {
      this.extraParams = {
        ...this.extraParams,
        ...extraParams,
      }
      this.refetchData()
    },
    loadData() {
    },
    selectApplyDoc(data) {
      this.$store.commit(`${this.MODULE_NAME}/GET`, data)
    },
    getStatus(id) {
      return this.$store.getters['staticModule/getAdditionalExamCheckStatus'](id)
    },
  },
  setup() {
    const MODULE_NAME = 'additionalExamCheck'
    const FILTER = false

    return {
      ...config(MODULE_NAME),
      MODULE_NAME,
      FILTER,
    }
  },
}
</script>
